export default __webpack_public_path__ + "static/media/premium-android.72c55bc3.png";